module.exports = __webpack_public_path__ + "static/media/Picture1water.df51672f.jpg";